module.exports = __webpack_public_path__ + "static/readm-ec7fdcf223b7eee6c9df0f5e03ca24e9.png";